import { useEntitlementsBootstrap } from '@whistler-ui/portal/hooks/useEntitlementsBootstrap';

export const EntitlementsBootstrap = () => {
  useEntitlementsBootstrap();

  return null;
};
